import { MultiLanguage } from "../../MultiLanguage";

export abstract class Step {
    private _order: number;
    private _error: boolean;
    protected _name: string | MultiLanguage;

    constructor(step: any) {
        this._order = step.order;
        this._error = false;
    }

    public get order() {
        return this._order;
    }

    public get name() {
        return this._name;
    }

    public set error(error: boolean) {
        this._error = error;
    }
    public get error() {
        return this._error;
    }
}